import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { haptic } from "../lib/telegram";

interface Props {
  title?: string;
  message: string;
}

export function SuccessScreen({ title = "Заявка принята", message }: Props) {
  const navigate = useNavigate();

  useEffect(() => {
    haptic("success");
  }, []);

  return (
    <div className="min-h-[100dvh] flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-8 text-center">
        <div className="icon-tile icon-tile-lg bg-[var(--icon-green-bg)] text-[var(--icon-green)] mb-5">
          ✓
        </div>
        <h2 className="text-[28px] leading-tight font-bold text-ink tracking-tight mb-3">
          {title}
        </h2>
        <p className="text-secondary text-[15px] leading-relaxed whitespace-pre-line max-w-sm">
          {message}
        </p>
      </div>
      <div className="p-5">
        <button className="ios-btn ios-btn-primary" onClick={() => navigate("/")}>
          В главное меню
        </button>
      </div>
    </div>
  );
}
